import { IDataProviderFilter, IFilter } from 'core-components/types'
import { userApi } from 'onboarding/api/userApi'
import { TOnboardingUser } from 'onboarding/classes/models/onboardingUser'
import { isDataProviderFilter, isFilter } from 'onboarding/utils/common'

class UserService {
  public async fetchManyByCrudOptions(filter: IDataProviderFilter) {
    const result: { Data: TOnboardingUser[]; Errors: string | undefined } = {
      Data: [],
      Errors: undefined,
    }
    try {
      const findIdFilterItem = (i: IDataProviderFilter | IFilter) =>
        isFilter(i) && i.field === 'id' && i.value && typeof i.value === 'string'
      const filterItem = filter.filters
        .flatMap((i) => (isDataProviderFilter(i) ? i.filters : i))
        .find(findIdFilterItem) as IFilter | undefined

      if (filterItem?.value) {
        result.Data = await this.fetchMany(filterItem.value as string)
      }
    } catch (e: any) {
      result.Data = []
      result.Errors = e.message
    }

    return result
  }

  public fetchMany(text: string) {
    return userApi.fetchMany(text)
  }
}

export const userService = new UserService()
